<template>
 <div id="login-page" data-component="login" class="full-height-container">
    <login-layout v-if="!isLoggedIn">
      <login-form-online v-if="!isKMOffline"/>
      <login-form-offline v-else/>
    </login-layout>
  </div>
</template>

<script>
//---- components ---------
import LoginFormOnline from "./LoginFormOnline.vue";
import LoginFormOffline from "./LoginFormOffline.vue";
import LoginLayout from "./LoginLayout.vue";
//---- mixins -------------
//---- services -----------
//---- 3rd-parties --------
import { mapGetters } from "vuex";

export default {
  name: "login",
  components: { LoginFormOnline, LoginFormOffline, LoginLayout },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/loggedIn",
      isKMOffline: "kmOffline/isKMOffline",
    }),
  }
};
</script>